<app-loader
	[enableCircle]="true"
	[isActive]="isLoading.value$ | async"
	[isAfterViewInit]="false"
></app-loader>
<h1 matDialogTitle>
	<div class="flex flex-row items-center justify-start gap-2">
		<div class="flex-auto"></div>
		@if(activeRecording$.value; as recording ) {
		<div class="flex items-center space-x-2">
			<!-- Check out button for recordings -->
			<button
				(click)="checkOutActiveRecording()"
				[matTooltipTemplate]="checkOutTooltip"
				[matTooltipTemplateContext]="{ time: recording }"
				class="flex size-6 p-0 leading-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 bg-red-500 disabled:opacity-50 disabled:cursor-not-allowed"
				matTooltip
				tabindex="-1"
				type="button"
			>
				<mat-icon
					class="text-center"
					inline
					>logout</mat-icon
				>
			</button>
		</div>
		<div class="flex items-center space-x-2">
			<!-- Check out button for recordings -->
			<button
				(click)="handleUpdate()"
				[matTooltip]="(recording.getRawValue().type === 'work' ? 'comego.state.pause' : 'comego.state.resume') | translate"
				class="mat-button-square wflex-[0_0_auto]"
				mat-button
				tabindex="-1"
			>
				<mat-icon> {{ recording.getRawValue().type === 'work' ?  'pause_circle' : 'not_started' }} </mat-icon>
			</button>
		</div>
		}
		<div class="flex items-center space-x-2">
			<button
				(click)="deleteAllTimes(confirmSingleDeleteDialog)"
				[disabled]="(isLoading.value$ | async) || group.controls.times.length === 0"
				*ngIf="canDelete$ | async"
				color="warn"
				mat-stroked-button
				tabindex="-1"
			>
				<span translate>utils.delete</span>
			</button>
			<button
				mat-icon-button
				matDialogClose
				tabindex="-1"
			>
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>
</h1>
<mat-dialog-content
	cdkTrapFocus
	class="!overflow-y-auto !max-h-[calc(100vh-200px)]"
>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="this.group"
		*ngIf="this.group as grp"
		class="flex flex-col"
	>
		<div class="flex flex-row gap-2">
			<div class="flex flex-auto flex-col items-stretch justify-start gap-2 lg:wflex-[1_0_440px]">
				<ng-container *ngIf="{ shown: isFieldShown('user') } as ctrl">
					<div
						(click)="$event.preventDefault(); group.controls.user.enabled && !hasActiveRecording && openUserPicker()"
						[ngClass]="{ 'cursor-pointer': group.controls.user.enabled && !hasActiveRecording }"
						*ngIf="ctrl.shown && (workspace$canManageOthers.value$ | async)"
						class="flex w-full flex-col"
					>
						<mat-form-field
							[ngClass]="{ 'opacity-50': hasActiveRecording }"
							appearance="standard"
							class="user-picker-item form-control-interactive mat-form-field-no-label"
						>
							<div
								*ngIf="groupValue.user as user"
								class="-mb-16px flex items-center space-x-1.5"
							>
								<app-user-avatar
									[userId]="user.id"
									class="rounded-full"
									size="40px"
								></app-user-avatar>
								<div class="flex flex-auto flex-col leading-none pl-1">
									<span>{{ user.name }}</span>
								</div>
								<button
									(click)="$event.preventDefault(); $event.stopPropagation(); patchValue({ user: null })"
									*ngIf="(postDiffUser$ | async) && !hasActiveRecording"
									mat-icon-button
								>
									<mat-icon>clear</mat-icon>
								</button>
							</div>
							<input
								[disabled]="group.controls.user.disabled || hasActiveRecording"
								[value]="groupValue.user"
								class="!pointer-events-none"
								matInput
								readonly
							>
						</mat-form-field>
					</div>
				</ng-container>
				<ng-container *ngIf="{ shown: isFieldShown('date') } as ctrl">
					<div
						(click)="$event.preventDefault(); group.controls.date.enabled && !hasActiveRecording && openCalPicker()"
						[ngClass]="{ 'cursor-pointer': group.controls.date.enabled && !hasActiveRecording }"
						*ngIf="ctrl.shown"
						class="flex w-full flex-col"
					>
						<mat-form-field
							[ngClass]="{ 'opacity-50': hasActiveRecording }"
							appearance="standard"
							class="pointer-events-none"
						>
							<mat-icon
								class="text-muted prefix-icon leading-none"
								matPrefix
								>calendar_month</mat-icon
							>
							<input
								[disabled]="group.controls.date.disabled || hasActiveRecording"
								[value]="groupValue.date | formatDate"
								class="!pointer-events-none"
								matInput
							>
						</mat-form-field>
					</div>
				</ng-container>
			</div>
		</div>
		<!-- Existing Entries Section -->
		<ng-container
			*ngIf="{ entries: existingEntries$.value$ | async, overlappingIds: overlappingExistingEntryIds$ | async } as existingData"
		>
			<div
				*ngIf="existingData.entries?.length > 0"
				class="mat-bd-5 -mx-2 mb-2 flex flex-col space-y-1.5 rounded-lg px-3 pb-2 pt-2"
			>
				<div class="flex items-center justify-between mb-1">
					<h3 class="text-muted mat-typography">{{ 'comego.existingEntries' | translate }}</h3>
					<div class="flex items-center gap-1">
						<button
							(click)="$event.stopPropagation(); deleteExistingEntries()"
							[disabled]="isDeletingEntries$.value$ | async"
							[matTooltip]="'utils.deleteAllEntries' | translate"
							class="!h-6 !w-6 !flex !items-center !justify-center"
							mat-icon-button
							type="button"
						>
							<mat-progress-spinner
								[diameter]="16"
								[mode]="'indeterminate'"
								[strokeWidth]="2"
								*ngIf="isDeletingEntries$.value$ | async"
							></mat-progress-spinner>
							<mat-icon
								*ngIf="!(isDeletingEntries$.value$ | async)"
								class="!leading-none"
							>
								delete
							</mat-icon>
						</button>
					</div>
				</div>
				<div class="flex flex-col space-y-1.5">
					<div
						[ngClass]="{ 'overlapping-entry': existingData.overlappingIds?.includes(entry.id) }"
						*ngFor="let entry of existingData.entries; trackBy: trackByEntryId"
						class="flex items-center justify-between p-2 bg-neutral-50 dark:bg-neutral-800 rounded border border-neutral-200 dark:border-neutral-700"
					>
						<div class="flex items-center space-x-2">
							<div
								[ngClass]="
                    entry.type === 'work'
                      ? 'border border-green-400 bg-green-600/90 dark:bg-green-600/60 text-green-200'
                      : entry.type === 'absence'
                        ? 'border border-violet-400 bg-violet-800/90 dark:bg-violet-800/60 text-violet-100'
                        : 'dark:bg-neutral-600 bg-neutral-600/80'
                  "
								class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100"
							>
								<mat-icon
									class="text-center"
									inline
								>
									{{ iconMap[entry.type] ?? 'schedule' }}
								</mat-icon>
							</div>
							<div class="flex flex-col leading-tight">
								<div class="flex items-center space-x-1.5">
									<span class="text-xs font-medium flex gap-1">
										<span>{{ formatTimeForDisplay(entry.start) }}</span>
										<span>-</span>
										<span>{{ formatTimeForDisplay(entry.end) }}</span></span
									>
									<span class="text-xs text-muted opacity-70">
										({{ calculateExistingEntryDuration(entry) | parseMsAsDuration: false }})
									</span>
								</div>
								<span
									*ngIf="entry.name"
									class="text-xs text-muted opacity-70"
									>{{
										entry.name
									}}</span
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
		<div class="mat-bd-5 -mx-2 flex flex-col rounded-lg px-4 pt-3 pb-3">
			<div class="xs:mb-4 mb-0 flex">
				<div class="flex flex-grow flex-col">
					<div class="flex flex-col">
						<ng-container *ngIf="duration$ | async as dur">
							<div class="flex flex-col space-y-0.5">
								<span class="text-muted mat-typography">
									{{ 'comego.types.work' | translate }}:
									{{ dur.working | parseMsAsDuration: false }}</span
								>
								@if(dur?.absence) {
								<span class="text-muted mat-typography">
									{{ 'comego.types.absence' | translate }}:
									{{ dur.absence | parseMsAsDuration: false }}</span
								>
								}
								<span
									[matTooltip]="(dur.pause - dur.realBreak) > 0
												? ('comego.breakQualifyAs' | translate: {
											shortBreak: dur.realBreak | parseMsAsDuration,
											break: dur.pause | parseMsAsDuration
											}) : null"
									class="text-muted mat-typography"
								>
									{{ 'comego.types.pause_short' | translate }}:
									{{ dur.pause | parseMsAsDuration: false }}
								</span>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="flex flex-row items-center gap-2">
					<ng-container *ngIf="currentDateHasSchedule$ | async">
						<!-- Desktop/Tablet: Full text button (≥640px) -->
						<button
							(click)="resetToSchedule()"
							class="!hidden xs:!inline-flex"
							mat-stroked-button
							type="button"
						>
							{{ 'schedules.resetToUserSchedule' | translate }}
						</button>
						<!-- Mobile: Icon only button (<640px) -->
						<button
							(click)="resetToSchedule()"
							[matTooltip]="'schedules.resetToUserSchedule' | translate"
							class="!flex xs:!hidden !h-6 !w-6 !items-center !justify-center"
							mat-icon-button
							type="button"
						>
							<mat-icon class="!leading-none">content_paste_go</mat-icon>
						</button>
					</ng-container>
					<button
						(click)="this.comegoDescriptionToggle$.update(!this.comegoDescriptionToggle$.value)"
						[matTooltip]="'comego.toggleDescription' | translate"
						class="!h-6 !w-6 !flex !items-center !justify-center"
						mat-icon-button
						type="button"
					>
						<mat-icon class="!leading-none">{{
							this.comegoDescriptionToggle$.value ? 'comment' : 'comments_disabled'
						}}</mat-icon>
					</button>
				</div>
			</div>
			<div
				*ngIf="{ times: getErrorObservable('times') | async } as error"
				class="flex flex-col xs:mt-2 mt-0 gap-2"
			>
				<ng-container
					*ngFor="let comegoGroup of group.controls.times.controls; let ctrlIndex = index; trackBy: ctrlIndex"
				>
					<div class="flex flex-col">
						<form
							(blur)="sortTimesOnBlur($event)"
							(submit)="$event.preventDefault()"
							[formGroup]="comegoGroup"
						>
							<div class="flex flex-row items-start space-x-2">
								<!-- Icon (always visible on left) -->
								<div
									[ngClass]="[
                      comegoGroup.getRawValue()?.type === 'work'
                        ? 'border  border-green-400  bg-green-600/90  dark:bg-green-600/60  text-green-200'
                        : comegoGroup.getRawValue()?.type === 'absence'
                          ? 'border  border-violet-400  bg-violet-800/90  dark:bg-violet-800/60  text-violet-100'
                          : comegoGroup.getRawValue()?.type === 'pause'
                            ? 'dark:bg-neutral-600 bg-neutral-600/80'
                            : comegoGroup.getRawValue()?.recording
                              ? ' border  border-green-400  bg-green-600/90  dark:bg-green-600/60  text-green-200'
                              : ' border  border-violet-400  bg-violet-800/90  dark:bg-violet-800/60  text-violet-100'
                    ]"
									*ngIf="calcType(iconMap[comegoGroup.getRawValue()?.type]) as type"
									class="mt-5 flex size-6 p-0 leading-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100"
								>
									<mat-icon
										class="text-center"
										inline
									>
										{{ type }}
									</mat-icon>
								</div>

								<!-- Center flexbox: contains type/time row + description row -->
								<div
									*ngIf="{ enabled: enabledTypes.value$ | async } as ctrl"
									class="flex flex-auto flex-col space-y-2"
								>
									<!-- Type and Time inputs row -->
									<div class="flex flex-col space-y-0 xs:flex-row xs:space-x-2 xs:gap-2">
										<!-- Type selector -->
										<mat-form-field
											[ngClass]="{ 'comego-type-readonly': comegoGroup.controls.type.disabled }"
											appearance="standard"
											class="group min-w-0 flex-1 pt-0.5"
										>
											<mat-label
												class="hidden xs:inline xs:opacity-0 xs:transition-opacity xs:group-hover:opacity-100"
												>{{
													'comego.type' | translate
												}}</mat-label
											>
											<mat-select
												(openedChange)="onTypeSelectOpenedChange($event, ctrlIndex, comegoGroup.getRawValue()?.type)"
												formControlName="type"
												panelClass="comego-type-select-panel"
											>
												<mat-select-trigger>
													<ng-container [ngSwitch]="comegoGroup.getRawValue()?.type">
														<ng-container *ngSwitchCase="'work'">{{
															'comego.types.work' | translate
														}}</ng-container>
														<ng-container *ngSwitchCase="'pause'">{{
															'comego.types.pause' | translate
														}}</ng-container>
														<ng-container *ngSwitchCase="'absence'">{{
															'comego.types.absence' | translate
														}}</ng-container>
														<ng-container *ngSwitchDefault>
															<ng-container *ngFor="let sub of absenceSubcategories">
																<ng-container
																	*ngIf="sub.id === comegoGroup.getRawValue()?.type"
																	>{{
																		sub | absenceTranslate
																	}}</ng-container
																>
															</ng-container>
															@if
															(!isAbsenceSubcategoryType(comegoGroup.getRawValue()?.type))
															{
															{{ 'comego.types.absence' | translate }}
															}
														</ng-container>
													</ng-container>
												</mat-select-trigger>

												<!-- Options -->
												<mat-option
													[disabled]="!ctrl.enabled.work"
													value="work"
												>
													<div class="flex flex-row items-center gap-2">
														<div
															class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 p-0 leading-6 border border-green-400 bg-green-600/90 dark:bg-green-600/60 text-green-200"
														>
															<mat-icon
																class="text-center mr-0"
																inline
																style="margin-right: 0px"
															>
																work_history
															</mat-icon>
														</div>
														<div>{{ 'comego.types.work' | translate }}</div>
													</div>
												</mat-option>
												<mat-option
													[disabled]="!ctrl.enabled.pause"
													value="pause"
												>
													<div class="flex flex-row items-center gap-2">
														<div
															class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 p-0 leading-6 dark:bg-neutral-600 bg-neutral-600/80"
														>
															<mat-icon
																class="text-center mr-0"
																inline
																style="margin-right: 0px"
															>
																pause
															</mat-icon>
														</div>
														<div>{{ 'comego.types.pause' | translate }}</div>
													</div>
												</mat-option>
												@if ( comegoGroup.getRawValue()?.type && comegoGroup.getRawValue()?.type
												!== 'work' && comegoGroup.getRawValue()?.type !== 'pause' &&
												comegoGroup.getRawValue()?.type !== 'absence' &&
												!isAbsenceSubcategoryType(comegoGroup.getRawValue()?.type) ) {
												<mat-option
													[value]="comegoGroup.getRawValue()?.type"
													class="comego-absence-orphan"
												>
													{{ 'comego.types.absence' | translate }}
												</mat-option>
												} @if ((!absenceSubcategories?.length ||
												!hasVisibleAbsenceSubcategories(absenceSubcategories) ) &&
												(canCreateAbsencesForSelectedUser$ | async ) ) {
												<mat-option
													[disabled]="!ctrl.enabled.absence"
													value="absence"
												>
													<div class="flex flex-row items-center gap-2">
														<div
															class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 p-0 leading-6 border border-violet-400 bg-violet-800/90 dark:bg-violet-800/60 text-violet-100"
														>
															<mat-icon
																class="text-center mr-0"
																inline
																style="margin-right: 0px"
															>
																beach_access
															</mat-icon>
														</div>
														<div>{{ 'comego.types.absence' | translate }}</div>
													</div>
												</mat-option>
												} @else if(canCreateAbsencesForSelectedUser$ | async ) {
												<mat-option
													(click)="$event.preventDefault(); $event.stopPropagation(); toggleAbsenceSubmenu(ctrlIndex)"
													(mouseenter)="openAbsenceSubmenu(ctrlIndex)"
													(mouseleave)="scheduleCloseAbsenceSubmenu()"
													[class.comego-absence-trigger--open]="absenceSubmenuOpenIndex === ctrlIndex"
													[disabled]="true"
													class="comego-absence-trigger"
												>
													<div class="flex w-full flex-row items-center gap-2">
														<div
															class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 p-0 leading-6 border border-violet-400 bg-violet-800/90 dark:bg-violet-800/60 text-violet-100"
														>
															<mat-icon
																class="text-center mr-0"
																inline
																style="margin-right: 0px"
															>
																beach_access
															</mat-icon>
														</div>
														<div class="flex-1">
															{{ 'comego.types.absence' | translate }}
														</div>
														<mat-icon
															class="comego-absence-trigger__chevron"
															inline
														>
															chevron_right
														</mat-icon>
													</div>
												</mat-option>
												@for (subcategory of absenceSubcategories; track subcategory.id) { @if
												(absencesForUser(subcategory, groupValue)) {
												<mat-option
													(mouseenter)="openAbsenceSubmenu(ctrlIndex)"
													(mouseleave)="scheduleCloseAbsenceSubmenu()"
													[class.comego-absence-sub--visible]="absenceSubmenuOpenIndex === ctrlIndex"
													[disabled]="!ctrl.enabled.absence"
													[value]="subcategory.id"
													class="comego-absence-sub"
												>
													<div class="flex flex-row items-center gap-2">
														<div
															class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 p-0 leading-6 border border-violet-400 bg-violet-800/90 dark:bg-violet-800/60 text-violet-100"
														>
															<mat-icon
																class="text-center mr-0"
																inline
																style="margin-right: 0px"
															>
																beach_access
															</mat-icon>
														</div>
														<div>{{ subcategory | absenceTranslate }}</div>
													</div>
												</mat-option>
												} } }
											</mat-select>
										</mat-form-field>

										<!-- Time inputs -->
										<div class="time-inputs-row flex min-w-0 items-center justify-between">
											<div
												[ngClass]="[
													(isAMPM$ | async) ? 'w-[72px] min-w-[72px]' : 'w-[48px] min-w-[48px]',
													comegoGroup.controls.start.disabled ? 'comego-time-readonly' : ''
												]"
											>
												<app-time-input
													(click)="$event.stopPropagation(); this.selectInput($event, startInpRef)"
													(focus)="this.selectInput($event, startInpRef)"
													(keydown.enter)="$event.preventDefault()"
													[displayFormat]="false"
													[inputPlaceholder]="'timer.time.start' | translate"
													[maxlength]="5"
													#startInpRef="nativeElement"
													#tStartFormField
													elementRef
													formControlName="start"
													matInput
												>
													<ng-template
														let-control="control"
														let-inputPlaceholder="inputPlaceholder"
														timeInputControl
													>
														<mat-form-field
															appearance="standard"
															class="group"
															fxFill
														>
															<mat-label
																class="hidden xs:inline xs:opacity-0 xs:transition-opacity xs:group-hover:opacity-100"
																>{{
																	inputPlaceholder
																}}</mat-label
															>
															<input
																(blur)="updatePreviousEntryEndTime($event, ctrlIndex)"
																[formControl]="control"
																[placeholder]="inputPlaceholder"
																matInput
																type="text"
															>
														</mat-form-field>
													</ng-template>
												</app-time-input>
											</div>
											<span class="tg-seperator mx-2 flex-shrink-0 text-center font-bold -mt-3">
												-
											</span>
											@if (comegoGroup.getRawValue()?.recording) {<ng-container
												*ngTemplateOutlet="recordingText; context: { entry: comegoGroup.getRawValue(), date: group.getRawValue().date }"
											></ng-container
											>} @else {
											<div
												[ngClass]="(isAMPM$ | async) ? 'w-[72px] min-w-[72px]' : 'w-[48px] min-w-[48px]'"
											>
												<app-time-input
													(click)="$event.stopPropagation(); this.selectInput($event, endInpRef)"
													(focus)="this.selectInput($event, endInpRef)"
													(keydown.enter)="$event.preventDefault()"
													[displayFormat]="false"
													[inputPlaceholder]="'timer.time.end' | translate"
													[maxlength]="5"
													#endInpRef="nativeElement"
													#tEndFormField
													elementRef
													formControlName="end"
													matInput
												>
													<ng-template
														let-control="control"
														let-inputPlaceholder="inputPlaceholder"
														timeInputControl
													>
														<mat-form-field
															appearance="standard"
															class="group"
															fxFill
														>
															<mat-label
																class="hidden xs:inline xs:opacity-0 xs:transition-opacity xs:group-hover:opacity-100"
																>{{
																	inputPlaceholder
																}}</mat-label
															>
															<input
																(blur)="updateNextEntryStartTime($event, ctrlIndex)"
																[formControl]="control"
																[placeholder]="inputPlaceholder"
																matInput
																type="text"
															>
															<mat-hint
																*ngIf="calculateDuration(comegoGroup, ctrlIndex) as duration"
																class="pl-1.5"
																>{{
																	duration | parseMsAsDuration: false
																}}</mat-hint
															>
														</mat-form-field>
													</ng-template>
												</app-time-input>
											</div>
											}
										</div>
									</div>

									<!-- Description field (always full-width in its own row) -->
									<mat-form-field
										*ngIf="this.comegoDescriptionToggle$.value && comegoGroup.value.type != 'pause'"
										appearance="standard"
										class="w-full description-field"
									>
										<input
											(blur)="changeDescriptionsForToday(comegoGroup.value.name, applyToAllDialog)"
											class="text-black/60 dark:text-white/70"
											formControlName="name"
											matInput
											placeholder="{{ 'Description' | translate }}"
											type="text"
										>
										<mat-hint class="w-full text-right"
											>{{ comegoGroup.value.name?.length ?? 00 }}/ {{ maxLength }}</mat-hint
										>
									</mat-form-field>
								</div>

								<div class="mt-3 flex flex-shrink-0 space-x-2 opacity-40 group-hover:opacity-100">
									<!-- Delete button (always visible on right) -->
									<button
										(click)="deleteItem(ctrlIndex, confirmSingleDiscardDialog)"
										[disabled]="comegoGroup.disabled || (this.data?.time?.lockItem && ctrlIndex === 0)"
										mat-icon-button
									>
										<mat-icon>cancel</mat-icon>
									</button>
								</div>
							</div>
						</form>
						@if(error.times?.index === ctrlIndex ) { @if (!error.times?.warning) {
						<div class="text-warn -mt-2 ml-8 text-sm">
							{{ error.times.content | translate: (error.times.args || {} | translateArgs) }}
						</div>
						<div>{{ error.lenght }}</div>
						} @else {
						<div class="-mt-[22px] -mb-2 ml-auto flex flex-shrink-0 sm:mr-[29px] mr-[6%] text-gray-500">
							<mat-icon
								[matTooltip]=" error.times.content | translate: (error.times.args || {} | translateArgs)"
								class="text-lg"
							>
								info
							</mat-icon>
						</div>
						} }
					</div>
				</ng-container>
				<div class="xs:-mt-4 mt-0 flex justify-center">
					<span
						[matTooltip]="(isDailyMaxReachedOrExceededByCombined$ | async) ? ('comego.dailyMaxReachedHint' | translate) : null"
						[matTooltipDisabled]="!(isDailyMaxReachedOrExceededByCombined$ | async)"
						class="inline-flex"
					>
						<button
							(click)="addTime()"
							[disabled]="group.disabled || !(canAddTime.value$ | async) || (isDailyMaxReachedOrExceededByCombined$ | async)"
							color="primary"
							mat-icon-button
						>
							<mat-icon>add</mat-icon>
						</button>
					</span>
				</div>
			</div>
		</div>
	</form>
</mat-dialog-content>
<ng-container
	*ngIf="{
      times: getErrorObservable('times') | async,
      manual: error$.value$ | async,
    } as error"
>
	<div class="inset-x-0 mx-4 my-4">
		<div
			*ngIf="error.manual as err"
			class="alert alert-danger alert-tight rounded py-2"
		>
			{{ err.message | translate: (err.args | translateArgs) }}
		</div>
		<ng-container *ngIf="!error.manual && error.times && error.times.index === undefined && error.times as br">
			<div
				[matTooltip]=" br.content === 'errors.times.comego.breakRuleNotice' ?
			('errors.times.comego.breakRuleDetailed' | translate: (br.args || {} | translateArgs)): null"
				class="alert alert-danger alert-tight rounded py-2"
			>
				{{ br.content | translate: (br.args || {} | translateArgs) }}
			</div>
		</ng-container>
	</div>
</ng-container>
<ng-container *ngIf="getErrorObservable('date') | async as error">
	<ng-container *ngIf="error as br">
		<div class="inset-x-0 mx-4 mb-4">
			<div class="alert alert-danger alert-tight rounded py-2">
				{{ br.content | translate: (br.args || {} | translateArgs) }}
			</div>
		</div>
	</ng-container>
</ng-container>
<ng-container *ngIf="(overlappingExistingEntryIds$ | async)?.length > 0">
	<div class="inset-x-0 mx-4 mb-4">
		<div class="alert alert-danger alert-tight rounded py-2">{{ 'errors.times.comego.overlap' | translate }}</div>
	</div>
</ng-container>
<mat-dialog-actions class="mat-action-filled">
	<button
		(click)="submit()"
		[color]="'primary'"
		[disabled]="group.pristine || (((!error.times?.warning && group.invalid) || ((error$.value$ | async) && !error$.value?.test)) && (preventDeviatingWorkingHours | async)) || ((overlappingExistingEntryIds$ | async)?.length > 0)"
		*ngIf="{ times : getErrorObservable('times') | async } as error"
		class="mat-action-filled"
		mat-flat-button
	>
		{{ 'comego.bulk-update' | translate }}
	</button>
</mat-dialog-actions>

<ng-template
	#recordingText
	let-date="date"
	let-ref="entry"
>
	<div class="flex flex-col items-start mt-5">
		<div
			[ngClass]="(isAMPM$ | async) ? 'w-[72px] min-w-[72px]' : 'w-[48px] min-w-[48px]'"
			class="flex items-center justify-start text-red-500 animate-pulse -mt-2"
		>
			<mat-icon class="!text-md !mt-[0.2rem] placeholder:leading-none">fiber_manual_record</mat-icon>
			<span class="text-md font-medium uppercase -ml-[0.6rem]">rec</span>
		</div>
		<div class="flex flex-col items-center mt-1 w-full">
			<mat-divider
				[horizontal]="true"
				class="w-full !border-t-1 !border-neutral-800 dark:!border-neutral-100"
			></mat-divider>
			<ng-container *ngIf="now$ | async as now">
				<span class="text-sm mt-1">
					{{
						ref.start | dfnsParse: 'HH:mm' : date | dfnsDifferenceInSeconds: now | parseMsAsDuration: false
					}}
				</span>
			</ng-container>
		</div>
	</div>
</ng-template>

<ng-template
	#applyToAllDialog
	let-data="dialogData"
	let-ref="dialogRef"
>
	<mat-dialog-content> <p>{{ 'comego.descriptionToAll' | translate }}</p> </mat-dialog-content>
	<mat-dialog-actions align="end">
		<button
			(click)="ref.close(true)"
			mat-stroked-button
		>
			{{ 'utils.confirm' | translate }}
		</button>
		<button
			(click)="ref.close(false)"
			mat-stroked-button
		>
			{{ 'utils.cancel' | translate }}
		</button>
	</mat-dialog-actions>
</ng-template>

<ng-template
	#confirmSingleDeleteDialog
	let-data="dialogData"
	let-ref="dialogRef"
>
	<div
		class="mat-dialog-title-base flex flex-col"
		matDialogTitle
	>
		<h4 class="my-0">{{ 'utils.confirmDeletion' | translate }}</h4>
	</div>
	<mat-dialog-content> <p>{{ 'comego.confirmDeleteAllEntries' | translate }}</p> </mat-dialog-content>
	<mat-dialog-actions align="end">
		<button
			(click)="ref.close(false)"
			mat-stroked-button
		>
			{{ 'utils.cancel' | translate }}
		</button>
		<button
			(click)="ref.close(true)"
			color="warn"
			mat-stroked-button
		>
			{{ 'utils.delete' | translate }}
		</button>
	</mat-dialog-actions>
</ng-template>
<ng-template
	#confirmSingleDiscardDialog
	let-data="dialogData"
	let-ref="dialogRef"
>
	<div
		class="mat-dialog-title-base flex flex-col"
		matDialogTitle
	>
		<h4 class="my-0">{{ 'utils.confirmDiscard' | translate }}</h4>
	</div>
	<mat-dialog-content> <p>{{ 'comego.confirmDisacrd' | translate }}</p> </mat-dialog-content>
	<mat-dialog-actions align="end">
		<button
			(click)="ref.close(false)"
			mat-stroked-button
		>
			{{ 'utils.cancel' | translate }}
		</button>
		<button
			(click)="ref.close(true)"
			color="warn"
			mat-stroked-button
		>
			{{ 'utils.discard' | translate }}
		</button>
	</mat-dialog-actions>
</ng-template>

<ng-template
	#confirmDeleteDialog
	let-data="dialogData"
	let-ref="dialogRef"
>
	<div
		class="mat-dialog-title-base flex flex-col"
		matDialogTitle
	>
		<h4 class="my-0">{{ 'utils.confirmDeletion' | translate }}</h4>
	</div>
	<mat-dialog-content> <p>{{ 'comego.confirmDeleteAllEntries' | translate }}</p> </mat-dialog-content>
	<mat-dialog-actions align="end">
		<button
			(click)="ref.close(false)"
			mat-stroked-button
		>
			{{ 'utils.cancel' | translate }}
		</button>
		<button
			(click)="ref.close(true)"
			color="warn"
			mat-stroked-button
		>
			{{ 'utils.deleteAllEntries' | translate }}
		</button>
	</mat-dialog-actions>
</ng-template>

<ng-template
	#checkOutTooltip
	let-time="time"
>
	<ng-container>
		<div class="flex flex-row items-center justify-start gap-2">
			<div class="flex flex-col"><span class="font-bold">{{ 'comego.widget.checkout' | translate }}</span></div>
		</div>
	</ng-container>
</ng-template>
